'use strict';

class SlickJs {
	constructor( $element, $config = {} ) {
		const $default = { rtl: window.rbb_vars.rtl === 'true' };
		const $slickConfig = {
			...$default,
			...$config,
		};
		jQuery( $element ).slick( $slickConfig );
	}
}

export default SlickJs;
